import { useEffect } from "react";
import IconUserActive from "../SvgIcon/IconUserActive";

export default function TimelineModal({ data, onClose }) {
    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => (document.body.style.overflow = "");
    }, []);

    if (!data) return null;

    return (
        <div className="nm-overlay" onClick={onClose}>
            <div className="nm-modal" onClick={(e) => e.stopPropagation()}>

                <div className="nm-header">
                    <h2 className="nm-title"><IconUserActive /> Vijay Timeline</h2>
                    <button className="nm-close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="timeline">
                    {data.map((item, index) => (
                        <div className="timeline-item" key={index}>
                            <div className="timeline-dot"></div>
                            <div className="timeline-content">
                                <p className="timeline-time">{item.time}</p>
                                <p className="timeline-text">{item.text}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
}